import React, {useCallback} from 'react';
import {WebSocketOperationButton} from "../../components/web-socket/WebSocketOperationButton";
import {useEmployeeStore} from "../../api/EmployeeStore";
import {useTeamStore} from "../../api/TeamStore";
import {useWorkSiteStore} from "../../api/WorkSiteStore";
import HibobIcon from "../../components/icons/HibobIcon";

export default function HiBobSyncButton() {
    const loadEmployees = useEmployeeStore(state => state.refresh);
    const loadTeams = useTeamStore(state => state.refresh);
    const loadSites = useWorkSiteStore(state => state.refresh);

    const handleFinish = useCallback(() => {
        loadEmployees();
        loadTeams();
        loadSites();
    }, [loadEmployees, loadTeams, loadSites]);

    return (
        <WebSocketOperationButton
            endpoint="/api/operations/sync-hibob-employees"
            description="Synchronize employee data from HiBob to the local database."
            actionButtonLabel="HiBob Sync"
            icon={<HibobIcon/>}
            onFinish={handleFinish}
        />
    );
}